import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    addOrders: translate({ id: 'rm.sidebar.addorders' }),
  }))

  return api
}
